import * as React from 'react';

const Se24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#006AA7",
    d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#FECC00", d: "M8 13.25V18h2.5v-4.75H21v-2.5H10.5V6H8v4.75H3v2.5z" }));
Se24.Size = 24;
Se24.Title = "Se";

export { Se24 as default };
